import { EngagementBuyer } from '../models/engagement-buyer.model';
import { MarketplaceOpportunityStatus } from '../../opportunity/models/opportunity-status';
import { formatBusinessDatePt } from './timeline-dates';

// [#1299] The Buyer Selection - DFM window's note on a buyer: how the Seller's DFM selection had gone for them before
// the engagement was suspended - selected, rejected or declined, with the date. None for a buyer it never reached.
export const dfmOutcomeBeforeTheBreakOf = (buyer: EngagementBuyer): string | undefined => {
    const outcome = buyer.dfmOutcomeBeforeTheBreak;
    if (outcome === undefined || outcome === null || !buyer.dfmOutcomeBeforeTheBreakAtUtc) {
        return undefined;
    }

    const decision =
        outcome === MarketplaceOpportunityStatus.RejectedBySeller
            ? 'rejected'
            : outcome === MarketplaceOpportunityStatus.RejectedByBuyer
              ? 'declined'
              : 'selected';
    return `DFM before the suspension: ${decision} on ${formatBusinessDatePt(buyer.dfmOutcomeBeforeTheBreakAtUtc)}`;
};
